module.exports = {
          srcSet: "/media/workForYouBgMobile.d5174323-320.webp"+" 320w"+","+"/media/workForYouBgMobile.715dc1f9-375.webp"+" 375w",
          images:[ {path: "/media/workForYouBgMobile.d5174323-320.webp",width: 320,height: 196},{path: "/media/workForYouBgMobile.715dc1f9-375.webp",width: 375,height: 230}],
          src: "/media/workForYouBgMobile.d5174323-320.webp",
          toString:function(){return "/media/workForYouBgMobile.d5174323-320.webp"},
          placeholder: "data:image/webp;base64,UklGRpAAAABXRUJQVlA4IIQAAAAwBACdASoUAAwAPlEijkQjoiGYBAA4BQSzgFYANLhxmh/3i2Qv3TljDIAA/v/+ONMvlmSpyUe+qJq8N5ftiYtFGgtw45LOz2+4kaD2M176TvpHIP9gTn1mGf7exyZl60rVJ/PZlHeGCG0BzCeISq/ewAgsAqiepneGTERTLEq23utcAAA=",
          width: 320,
          height: 196
        }